import { ConfirmCodeType } from '@/store/slices/user/auth-modal-slice';
import fetcher from '@/utils/fetcher';

/** 이메일 인증 코드 발송 -> 남은 인증 시간을 리턴 */
const postSendConfirmEmail = async (type: ConfirmCodeType, email: string) => {
  try {
    const res = await fetcher.post(`/api/auth/verify/${type}/send`, {
      data: { email },
    });
    const remainSecond: number = res.data.data;
    return remainSecond;
  } catch (e) {
    return 0;
  }
};

export default postSendConfirmEmail;
